"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STANDALONE_USERDATA = exports.STANDALONE_USER = exports.STANDALONE_SOCIAL_CONFIG = exports.STANDALONE_PERMISSIONS = exports.STANDALONE_KEYCLOAK = exports.STANDALONE_CLEARANCE_ACTIONS = exports.STANDALONE_CLEARANCES = void 0;
var _common = require("./common");
var STANDALONE_PERMISSIONS = exports.STANDALONE_PERMISSIONS = {
  isAdminUser: true,
  isDecisionsAdmin: true,
  isDecisionsOperator: true,
  isDecisionsUser: true,
  isEngageAdmin: true,
  isEngagedUser: true,
  isRubyAdmin: true,
  isRubyUser: true,
  isSapphireAdmin: true,
  isSapphireUser: true,
  isTrendsAdmin: true,
  isTrendsUser: true,
  isMapperViewer: true,
  isMapperCreator: true,
  isMapperUpdater: true,
  isControlRoomViewer: true,
  isControlRoomCreator: true,
  isControlRoomUpdater: true,
  isUserManagementAdmin: true,
  isMapperSuppressor: true,
  isMapperAdmin: true,
  isSourceSuppressor: true,
  isRubyAllowed: true,
  isTrendsAllowed: true,
  isDecisionsdAllowed: true,
  isEngageAllowed: true,
  isSapphireAllowed: true,
  hasMappingGroupsAccess: true,
  hasCmsToolAccess: true,
  canEditMappingGroup: true,
  canEditTextOverlay: true,
  canEditPlaylist: true,
  canEditMultiWindow: true,
  isTabletCtrlUser: true,
  isTabletCtrlAdmin: true,
  isSystemConfigAdmin: true,
  isSystemConfigViewer: true,
  hasMonitoringDashboardAccess: true,
  hasSourcesDestinationsAccess: true,
  uStreamTrendsAdmin: true,
  uStreamEngageAdmin: true,
  uStreamDecisionAdmin: true,
  isSAMSourceViewer: true,
  isMappingGroupUpdater: true,
  canStartInteractiveViewer: true,
  canStopInteractiveViewer: true
};
var STANDALONE_USER = exports.STANDALONE_USER = null;
var STANDALONE_SOCIAL_CONFIG = exports.STANDALONE_SOCIAL_CONFIG = [];
var STANDALONE_USERDATA = exports.STANDALONE_USERDATA = {
  userID: {
    value: "399f0025-dad4-4d19-ae31-74f323e58132"
  },
  userName: "admin",
  systemID: {
    value: _common.STANDALONE_SYSTEMID
  },
  organization: "Userful Demo",
  version: "12.10.2",
  userSessionID: "007dc078-57a2-4ff6-955b-20f8f143b4f3",
  capabilities: {
    capabilities: [{
      name: "li-emerald-allow",
      value: '[\\"EMERALD\\"]'
    }, {
      name: "li-topaz-allow",
      value: '[\\"TOPAZ\\"]'
    }, {
      name: "li-amethyst-allow",
      value: '[\\"AMETHYST\\"]'
    }, {
      name: "li-ruby-allow",
      value: '[\\"RUBY\\"]'
    }, {
      name: "li-diamond-allow",
      value: '[\\"CONTROL_ROOM\\",\\"CONTROL_ROOM_MGR\\"]'
    }, {
      name: "li-sapphire-allow",
      value: '[\\"SAPPHIRE\\"]'
    }]
  },
  connectionID: "007dc078-57a2-4ff6-955b-20f8f143b4f3"
};
var STANDALONE_KEYCLOAK = exports.STANDALONE_KEYCLOAK = {
  authenticated: true,
  loginRequired: true,
  responseType: "code id_token token",
  flow: "hybrid",
  redirectUri: "/",
  silentCheckSsoFallback: true,
  enableLogging: true,
  messageReceiveTimeout: 10000,
  responseMode: "fragment",
  clientId: "userful-chronos-aether",
  authServerUrl: "/",
  realm: "userful",
  endpoints: {},
  silentCheckSsoRedirectUri: false,
  idToken: "standalone-token",
  idTokenParsed: {
    exp: 1692310090,
    iat: 1691506819,
    auth_time: 1689718090,
    jti: "4c1d9dba-1bf4-44db-8b51-688daafe89a0",
    iss: "/",
    aud: "userful-chronos-aether",
    sub: "399f0025-dad4-4d19-ae31-74f323e58132",
    typ: "ID",
    azp: "userful-chronos-aether",
    nonce: "e37e5056-4afb-4ff1-acec-e901cd5a4a25",
    session_state: "007dc078-57a2-4ff6-955b-20f8f143b4f3",
    at_hash: "lth0bct2BfhdU1Wc1AamIg",
    acr: "0",
    sid: "007dc078-57a2-4ff6-955b-20f8f143b4f3",
    email_verified: true,
    preferred_username: "admin",
    given_name: "",
    family_name: ""
  },
  token: "standalone-token",
  tokenParsed: {
    exp: 1692310090,
    iat: 1691506819,
    auth_time: 1689718090,
    jti: "2b804b15-64cf-47a6-b59e-a5ab58f2b56c",
    iss: "/",
    aud: ["userful-chronos", "realm-management", "account"],
    sub: "399f0025-dad4-4d19-ae31-74f323e58132",
    typ: "Bearer",
    azp: "userful-chronos-aether",
    nonce: "e37e5056-4afb-4ff1-acec-e901cd5a4a25",
    session_state: "007dc078-57a2-4ff6-955b-20f8f143b4f3",
    acr: "0",
    "allowed-origins": ["*"],
    realm_access: {
      roles: ["Artistic", "Decisions", "admin", "Remote", "default-roles-userful", "system_config_admin", "user_management_admin", "system_config_viewer", "offline_access", "Spaces", "TabletController", "monitoring_dashboard", "tablet_ctrl_admin", "uma_authorization", "Trends", "sources_destinations_admin", "Engage"]
    },
    resource_access: {
      "userful-chronos": {
        roles: ["ControlRoomViewer", "CdmAdmin", "CdmPhysicalVideoDestCreator", "CdmVideoWallsEndPointViewer", "SamConfigUpdater", "SurfaceComponentSuppressor", "SamSourceViewer", "SnapshotComponentSupressor", "InsetComponentCreator", "InsetViewer", "SurfaceComponentCreator", "CdmUpdater", "PowerManager", "CdmVideoWallsEndPointSuppressor", "VideoEngineComponentSuppressor", "SamConfigAdmin", "InsetComponentUpdater", "UClientComponentViewer", "ChannelViewer", "ControlRoomAdmin", "MeetingRoomViewer", "SnapshotViewer", "CdmPhysicalEndPointSuppressor", "ZeroClientComponentViewer", "ScheduleManager", "SamSourceSpecSuppressor", "SamPlayListDefSuppressor", "ChannelCreator", "CalibrationVideoWallViewer", "SinkStreamComponentCreator", "CdmPhysicalAudioDestViewer", "SinkStreamComponentViewer", "InsetComponentViewer", "SamSourceDefViewer", "SystemMonitoringDashboard", "SinkViewer", "SamConfigSuppressor", "CdmSuppressor", "SamSourceSuppressor", "FailoverManager", "SinkStreamComponentSuppressor", "MeetingRoomSuppressor", "ChannelSuppressor", "SamSourceDefUpdater", "MapperCreator", "SourceSuppressor", "RemoteSupport", "SourceViewer", "DestinationUpdater", "MapperUpdater", "CdmVideoWallsEndPointUpdater", "SceneViewer", "GeneralSettingManager", "SourceStreamComponentUpdater", "SourceUpdater", "SamSourceSpecViewer", "userful-chronos-admin", "SourceStreamComponentSuppressor", "CdmDestinationGroupsViewer", "SurfaceAdmin", "CalibrationAdmin", "CdmVideoWallsDestViewer", "CdmVideoWallsDestUpdater", "SamSourceAssetCreator", "CdmDestinationGroupsSuppressor", "InsetAdmin", "MapperAdmin", "BroadcastManager", "SamPlayListDefViewer", "CalibrationVideoWallSuppressor", "SceneAdmin", "SourceAdmin", "SurfaceComponentUpdater", "SamSourceDefCreator", "ChannelAdmin", "SamPlayListDefCreator", "CdmPhysicalVideoDestSuppressor", "VideoEngineComponentUpdater", "SceneComponentViewer", "MapperSuppressor", "SamConfigViewer", "MeetingRoomAdmin", "VideoEngineComponentViewer", "SurfaceComponentViewer", "CdmVideoWallsDestSuppressor", "SinkStreamComponentUpdater", "MeetingRoomCreator", "SamSourceCreator", "CalibrationVideoWallUpdater", "SnapshotComponentUpdater", "EndPointManager", "SamSourceUpdater", "LicenseUpdater", "SinkAdmin", "SnapshotAdmin", "SceneComponentSuppressor", "CdmPhysicalVideoDestViewer", "SnapshotComponentViewer", "CdmPhysicalEndPointUpdater", "SamPlayListDefUpdater", "CdmDestinationGroupsCreator", "SceneComponentCreator", "CdmPhysicalEndPointViewer", "CdmViewer", "CdmPhysicalEndPointCreator", "CalibrationVideoWallCreator", "ZeroClientComponentUpdater", "VideoEngineAdmin", "SnapshotComponentCreator", "ControlRoomUpdater", "SamSourceSpecUpdater", "CdmDestinationGroupsUpdater", "DestinationViewer", "SceneComponentUpdater", "CdmPhysicalAudioDestCreator", "InsetComponentSuppressor", "ChannelUpdater", "SamSourceAssetUpdater", "CdmPhysicalAudioDestSuppressor", "CdmVideoWallsDestCreator", "SamSourceAssetSuppressor", "MeetingRoomUpdater", "CdmPhysicalAudioDestUpdater", "CdmVideoWallsEndPointCreator", "LicenseViewer", "CdmCreator", "SourceCreator", "SamConfigCreator", "SourceStreamComponentCreator", "ControlRoomEditor", "CdmPhysicalVideoDestUpdater", "LicenseManager", "UClientComponentUpdater", "SamSourceDefSuppressor", "MapperViewer", "SamSourceSpecCreator", "ControlRoomCreator", "SamSourceAssetViewer", "ConfigureOnboardMediaDisplay", "SourceStreamComponentViewer"]
      },
      "realm-management": {
        roles: ["view-realm", "view-identity-providers", "impersonation", "view-events", "manage-users", "query-realms", "view-users", "view-clients", "view-authorization", "query-clients", "query-groups", "query-users"]
      },
      "userful-chronos-aether": {
        roles: ["userful-chronos-aether-admin", "EditPlaylist", "SystemBackup", "SystemRestore", "SourcesDestinations", "ControlRoomMgr", "EditTextOverlay", "SystemConfiguration", "EditMappingGroup", "ControlRoom", "MeetingRooms", "Launcher", "EditMultiWindow", "MappingGroups", "CmsTool"]
      },
      account: {
        roles: ["manage-account", "manage-account-links", "view-profile"]
      }
    },
    scope: "openid AccessPermission email profile",
    sid: "007dc078-57a2-4ff6-955b-20f8f143b4f3",
    email_verified: true,
    preferred_username: "admin",
    given_name: "",
    family_name: ""
  },
  sessionId: "007dc078-57a2-4ff6-955b-20f8f143b4f3",
  subject: "399f0025-dad4-4d19-ae31-74f323e58132",
  realmAccess: {
    roles: ["Artistic", "Decisions", "admin", "Remote", "default-roles-userful", "system_config_admin", "user_management_admin", "system_config_viewer", "offline_access", "Spaces", "TabletController", "monitoring_dashboard", "tablet_ctrl_admin", "uma_authorization", "Trends", "sources_destinations_admin", "Engage"]
  },
  resourceAccess: {
    "userful-chronos": {
      roles: ["ControlRoomViewer", "CdmAdmin", "CdmPhysicalVideoDestCreator", "CdmVideoWallsEndPointViewer", "SamConfigUpdater", "SurfaceComponentSuppressor", "SamSourceViewer", "SnapshotComponentSupressor", "InsetComponentCreator", "InsetViewer", "SurfaceComponentCreator", "CdmUpdater", "PowerManager", "CdmVideoWallsEndPointSuppressor", "VideoEngineComponentSuppressor", "SamConfigAdmin", "InsetComponentUpdater", "UClientComponentViewer", "ChannelViewer", "ControlRoomAdmin", "MeetingRoomViewer", "SnapshotViewer", "CdmPhysicalEndPointSuppressor", "ZeroClientComponentViewer", "ScheduleManager", "SamSourceSpecSuppressor", "SamPlayListDefSuppressor", "ChannelCreator", "CalibrationVideoWallViewer", "SinkStreamComponentCreator", "CdmPhysicalAudioDestViewer", "SinkStreamComponentViewer", "InsetComponentViewer", "SamSourceDefViewer", "SystemMonitoringDashboard", "SinkViewer", "SamConfigSuppressor", "CdmSuppressor", "SamSourceSuppressor", "FailoverManager", "SinkStreamComponentSuppressor", "MeetingRoomSuppressor", "ChannelSuppressor", "SamSourceDefUpdater", "MapperCreator", "SourceSuppressor", "RemoteSupport", "SourceViewer", "DestinationUpdater", "MapperUpdater", "CdmVideoWallsEndPointUpdater", "SceneViewer", "GeneralSettingManager", "SourceStreamComponentUpdater", "SourceUpdater", "SamSourceSpecViewer", "userful-chronos-admin", "SourceStreamComponentSuppressor", "CdmDestinationGroupsViewer", "SurfaceAdmin", "CalibrationAdmin", "CdmVideoWallsDestViewer", "CdmVideoWallsDestUpdater", "SamSourceAssetCreator", "CdmDestinationGroupsSuppressor", "InsetAdmin", "MapperAdmin", "BroadcastManager", "SamPlayListDefViewer", "CalibrationVideoWallSuppressor", "SceneAdmin", "SourceAdmin", "SurfaceComponentUpdater", "SamSourceDefCreator", "ChannelAdmin", "SamPlayListDefCreator", "CdmPhysicalVideoDestSuppressor", "VideoEngineComponentUpdater", "SceneComponentViewer", "MapperSuppressor", "SamConfigViewer", "MeetingRoomAdmin", "VideoEngineComponentViewer", "SurfaceComponentViewer", "CdmVideoWallsDestSuppressor", "SinkStreamComponentUpdater", "MeetingRoomCreator", "SamSourceCreator", "CalibrationVideoWallUpdater", "SnapshotComponentUpdater", "EndPointManager", "SamSourceUpdater", "LicenseUpdater", "SinkAdmin", "SnapshotAdmin", "SceneComponentSuppressor", "CdmPhysicalVideoDestViewer", "SnapshotComponentViewer", "CdmPhysicalEndPointUpdater", "SamPlayListDefUpdater", "CdmDestinationGroupsCreator", "SceneComponentCreator", "CdmPhysicalEndPointViewer", "CdmViewer", "CdmPhysicalEndPointCreator", "CalibrationVideoWallCreator", "ZeroClientComponentUpdater", "VideoEngineAdmin", "SnapshotComponentCreator", "ControlRoomUpdater", "SamSourceSpecUpdater", "CdmDestinationGroupsUpdater", "DestinationViewer", "SceneComponentUpdater", "CdmPhysicalAudioDestCreator", "InsetComponentSuppressor", "ChannelUpdater", "SamSourceAssetUpdater", "CdmPhysicalAudioDestSuppressor", "CdmVideoWallsDestCreator", "SamSourceAssetSuppressor", "MeetingRoomUpdater", "CdmPhysicalAudioDestUpdater", "CdmVideoWallsEndPointCreator", "LicenseViewer", "CdmCreator", "SourceCreator", "SamConfigCreator", "SourceStreamComponentCreator", "ControlRoomEditor", "CdmPhysicalVideoDestUpdater", "LicenseManager", "UClientComponentUpdater", "SamSourceDefSuppressor", "MapperViewer", "SamSourceSpecCreator", "ControlRoomCreator", "SamSourceAssetViewer", "ConfigureOnboardMediaDisplay", "SourceStreamComponentViewer"]
    },
    "realm-management": {
      roles: ["view-realm", "view-identity-providers", "impersonation", "view-events", "manage-users", "query-realms", "view-users", "view-clients", "view-authorization", "query-clients", "query-groups", "query-users"]
    },
    "userful-chronos-aether": {
      roles: ["userful-chronos-aether-admin", "EditPlaylist", "SystemBackup", "SystemRestore", "SourcesDestinations", "ControlRoomMgr", "EditTextOverlay", "SystemConfiguration", "EditMappingGroup", "ControlRoom", "MeetingRooms", "Launcher", "EditMultiWindow", "MappingGroups", "CmsTool"]
    },
    account: {
      roles: ["manage-account", "manage-account-links", "view-profile"]
    }
  },
  timeSkew: 0,
  refreshToken: "standalone-token",
  refreshTokenParsed: {
    exp: 1692310090,
    iat: 1691506819,
    jti: "57df52e4-0fb6-46d2-8b49-c1338d0d3abc",
    iss: "/",
    aud: "/",
    sub: "399f0025-dad4-4d19-ae31-74f323e58132",
    typ: "Refresh",
    azp: "userful-chronos-aether",
    nonce: "e37e5056-4afb-4ff1-acec-e901cd5a4a25",
    session_state: "007dc078-57a2-4ff6-955b-20f8f143b4f3",
    scope: "openid AccessPermission email profile",
    sid: "007dc078-57a2-4ff6-955b-20f8f143b4f3"
  }
};
var STANDALONE_CLEARANCES = exports.STANDALONE_CLEARANCES = [{
  clearanceLevel: {
    id: {
      value: "A5563BC9-1B6C-4738-84D1-6011F9A58116"
    },
    name: "RemoteUsers_execute",
    description: "Access permission for RemoteUsers to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "a6e6820a-da9b-418c-b8e2-9b69696e28d1"
  }],
  users: [],
  id: {
    value: "A5563BC9-1B6C-4738-84D1-6011F9A58116"
  }
}, {
  clearanceLevel: {
    id: {
      value: "4B568E9A-4F0C-4B8E-8B1D-77DC6E722433"
    },
    name: "SpacesAdministrators_edit",
    description: "Access permission for SpacesAdministrators to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "89af1c91-a894-4462-8522-aa534d1c76db"
  }],
  users: [],
  id: {
    value: "4B568E9A-4F0C-4B8E-8B1D-77DC6E722433"
  }
}, {
  clearanceLevel: {
    id: {
      value: "B9916B79-2FE4-4A9D-A3B2-C5C611107F46"
    },
    name: "TrendsAdministrators_edit",
    description: "Access permission for TrendsAdministrators to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "5effa869-d4c1-4e74-922a-e75c34b95d7d"
  }],
  users: [],
  id: {
    value: "B9916B79-2FE4-4A9D-A3B2-C5C611107F46"
  }
}, {
  clearanceLevel: {
    id: {
      value: "F8EF11FB-4999-45F4-B2AE-693A51116091"
    },
    name: "TrendsAdministrators_execute",
    description: "Access permission for TrendsAdministrators to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "5effa869-d4c1-4e74-922a-e75c34b95d7d"
  }],
  users: [],
  id: {
    value: "F8EF11FB-4999-45F4-B2AE-693A51116091"
  }
}, {
  clearanceLevel: {
    id: {
      value: "F4AFDD73-BD2E-4687-B3D6-789C7054F055"
    },
    name: "TrendsUsers_execute",
    description: "Access permission for TrendsUsers to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "230be47d-6efb-4fe5-b1cc-29988a31174d"
  }],
  users: [],
  id: {
    value: "F4AFDD73-BD2E-4687-B3D6-789C7054F055"
  }
}, {
  clearanceLevel: {
    id: {
      value: "D9D614C6-DEBF-4110-A9EF-7BFEE1E27AF7"
    },
    name: "DecisionsOperators_edit",
    description: "Access permission for DecisionsOperators to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "492e39be-f63f-47b1-bd02-59a2134c021e"
  }],
  users: [],
  id: {
    value: "D9D614C6-DEBF-4110-A9EF-7BFEE1E27AF7"
  }
}, {
  clearanceLevel: {
    id: {
      value: "56D670AB-C90A-4E4F-9486-3F58E9646B1E"
    },
    name: "EngageAdministrators_edit",
    description: "Access permission for EngageAdministrators to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "2664a768-db37-459b-a9cc-1f8a00da6417"
  }],
  users: [],
  id: {
    value: "56D670AB-C90A-4E4F-9486-3F58E9646B1E"
  }
}, {
  clearanceLevel: {
    id: {
      value: "F7E6866D-2B08-4738-94E3-177D816BC9B6"
    },
    name: "ArtisticUsers_edit",
    description: "Access permission for ArtisticUsers to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "4f2fa5a0-9aae-443d-b5af-240762b68468"
  }],
  users: [],
  id: {
    value: "F7E6866D-2B08-4738-94E3-177D816BC9B6"
  }
}, {
  clearanceLevel: {
    id: {
      value: "543B598D-7734-44E2-A8BC-B312FA46CAC0"
    },
    name: "DecisionsOperators_execute",
    description: "Access permission for DecisionsOperators to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "492e39be-f63f-47b1-bd02-59a2134c021e"
  }],
  users: [],
  id: {
    value: "543B598D-7734-44E2-A8BC-B312FA46CAC0"
  }
}, {
  clearanceLevel: {
    id: {
      value: "2F5088FD-974A-4CAE-A574-D94468EABB8D"
    },
    name: "RemoteUsers_edit",
    description: "Access permission for RemoteUsers to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "a6e6820a-da9b-418c-b8e2-9b69696e28d1"
  }],
  users: [],
  id: {
    value: "2F5088FD-974A-4CAE-A574-D94468EABB8D"
  }
}, {
  clearanceLevel: {
    id: {
      value: "EBC63996-6BAC-4400-832E-2B291FD2161F"
    },
    name: "ArtisticAdministrators_execute",
    description: "Access permission for ArtisticAdministrators to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "361b7e6e-4533-4219-b74a-929795b702c8"
  }],
  users: [],
  id: {
    value: "EBC63996-6BAC-4400-832E-2B291FD2161F"
  }
}, {
  clearanceLevel: {
    id: {
      value: "AF23FD64-1878-4057-9F31-C8D83E2FD7E9"
    },
    name: "EngageUsers_execute",
    description: "Access permission for EngageUsers to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "29817c55-7f75-4375-a4de-708c5eea2e0d"
  }],
  users: [],
  id: {
    value: "AF23FD64-1878-4057-9F31-C8D83E2FD7E9"
  }
}, {
  clearanceLevel: {
    id: {
      value: "6B615E9A-9DC4-4538-A9DD-E823C5A3F5F2"
    },
    name: "ArtisticUsers_execute",
    description: "Access permission for ArtisticUsers to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "4f2fa5a0-9aae-443d-b5af-240762b68468"
  }],
  users: [],
  id: {
    value: "6B615E9A-9DC4-4538-A9DD-E823C5A3F5F2"
  }
}, {
  clearanceLevel: {
    id: {
      value: "2F5A19D5-1209-48F0-92DA-FDB778EA3381"
    },
    name: "RemoteAdministrators_execute",
    description: "Access permission for RemoteAdministrators to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "de807fe6-3fa8-4ea5-a3a8-e0c46c2cec30"
  }],
  users: [],
  id: {
    value: "2F5A19D5-1209-48F0-92DA-FDB778EA3381"
  }
}, {
  clearanceLevel: {
    id: {
      value: "3D77DA53-F320-4486-ADA1-B114EE5C2BC7"
    },
    name: "ArtisticAdministrators_edit",
    description: "Access permission for ArtisticAdministrators to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "361b7e6e-4533-4219-b74a-929795b702c8"
  }],
  users: [],
  id: {
    value: "3D77DA53-F320-4486-ADA1-B114EE5C2BC7"
  }
}, {
  clearanceLevel: {
    id: {
      value: "7567590F-57BB-4FF3-8AED-5AA75231A9EF"
    },
    name: "Administrators_execute",
    description: "Access permission for Administrators to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "b1a34a73-a8ec-4f26-b17e-cc12cc98e2f7"
  }],
  users: [],
  id: {
    value: "7567590F-57BB-4FF3-8AED-5AA75231A9EF"
  }
}, {
  clearanceLevel: {
    id: {
      value: "7BEC359C-8B23-415D-9FA7-49174A649E73"
    },
    name: "SpacesAdministrators_execute",
    description: "Access permission for SpacesAdministrators to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "89af1c91-a894-4462-8522-aa534d1c76db"
  }],
  users: [],
  id: {
    value: "7BEC359C-8B23-415D-9FA7-49174A649E73"
  }
}, {
  clearanceLevel: {
    id: {
      value: "04B0F640-3710-4951-863C-6959D0197567"
    },
    name: "EngageAdministrators_execute",
    description: "Access permission for EngageAdministrators to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "2664a768-db37-459b-a9cc-1f8a00da6417"
  }],
  users: [],
  id: {
    value: "04B0F640-3710-4951-863C-6959D0197567"
  }
}, {
  clearanceLevel: {
    id: {
      value: "F88A1023-4835-4C40-B545-7B843EAE073F"
    },
    name: "Administrators_edit",
    description: "Access permission for Administrators to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "b1a34a73-a8ec-4f26-b17e-cc12cc98e2f7"
  }],
  users: [],
  id: {
    value: "F88A1023-4835-4C40-B545-7B843EAE073F"
  }
}, {
  clearanceLevel: {
    id: {
      value: "F6201259-63D3-4E6F-8744-EDC42AEE3B11"
    },
    name: "TrendsUsers_edit",
    description: "Access permission for TrendsUsers to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "230be47d-6efb-4fe5-b1cc-29988a31174d"
  }],
  users: [],
  id: {
    value: "F6201259-63D3-4E6F-8744-EDC42AEE3B11"
  }
}, {
  clearanceLevel: {
    id: {
      value: "EB028104-E90C-445A-9DA1-7D2862BCD75B"
    },
    name: "DecisionsAdministrators_execute",
    description: "Access permission for DecisionsAdministrators to execute",
    actions: [{
      value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
    }],
    editable: false
  },
  groups: [{
    value: "2b2a1b33-8f78-466f-a55d-d3d3fb007b21"
  }],
  users: [],
  id: {
    value: "EB028104-E90C-445A-9DA1-7D2862BCD75B"
  }
}, {
  clearanceLevel: {
    id: {
      value: "D9B096EA-2BD8-43F7-92F7-8A4841EAB9FA"
    },
    name: "DecisionsAdministrators_edit",
    description: "Access permission for DecisionsAdministrators to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "2b2a1b33-8f78-466f-a55d-d3d3fb007b21"
  }],
  users: [],
  id: {
    value: "D9B096EA-2BD8-43F7-92F7-8A4841EAB9FA"
  }
}, {
  clearanceLevel: {
    id: {
      value: "9409D3EE-53AA-45AE-991A-3A0012D7FF4D"
    },
    name: "RemoteAdministrators_edit",
    description: "Access permission for RemoteAdministrators to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "de807fe6-3fa8-4ea5-a3a8-e0c46c2cec30"
  }],
  users: [],
  id: {
    value: "9409D3EE-53AA-45AE-991A-3A0012D7FF4D"
  }
}, {
  clearanceLevel: {
    id: {
      value: "8C0C9F7E-84D2-4F9B-A4AF-0B8324B1F4BC"
    },
    name: "EngageUsers_edit",
    description: "Access permission for EngageUsers to edit",
    actions: [{
      value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
    }],
    editable: false
  },
  groups: [{
    value: "29817c55-7f75-4375-a4de-708c5eea2e0d"
  }],
  users: [],
  id: {
    value: "8C0C9F7E-84D2-4F9B-A4AF-0B8324B1F4BC"
  }
}];
var STANDALONE_CLEARANCE_ACTIONS = exports.STANDALONE_CLEARANCE_ACTIONS = [{
  id: {
    value: "5C216D5D-3D7F-4654-8F5B-949DECC77A7D"
  },
  name: "create",
  description: "Allow create action to attached content"
}, {
  id: {
    value: "8C57E79E-23CA-4020-835B-C77D8C5735BA"
  },
  name: "edit",
  description: "Allow edit actions (create, view, update, delete) to attached content"
}, {
  id: {
    value: "D9F05602-EDFB-4C0E-BA7D-81729B26A512"
  },
  name: "delete",
  description: "Allow delete action to attached content"
}, {
  id: {
    value: "15DA4385-6ADE-4562-9201-07B04E670223"
  },
  name: "update",
  description: "Allow update action to attached content"
}, {
  id: {
    value: "1380ECA5-62CC-4853-A203-7A64C51CBDA5"
  },
  name: "use",
  description: "Allow use action to attached content"
}, {
  id: {
    value: "BE96AFF8-6771-47A5-A09B-12616CC911D1"
  },
  name: "view",
  description: "Allow view action to attached content"
}, {
  id: {
    value: "DAD5A4E3-820B-4A1D-AD4C-746C5FCAD592"
  },
  name: "execute",
  description: "Allow execute actions (create, view, use) to attached content"
}];